import React from "react";

import { InterceptStats as InterceptStatsComponent } from "heat-next";

import { useSessionDetailsContext } from "@/context/session-details/session-details";

import { ComponentWrapper } from "@/pages/shared/shared.styles";

import ContentLoader from "@/components/content-loader/content-loader";
import EmptyState from "@/components/empty-state/empty-state";
import { EmptyStateType } from "@/components/empty-state/empty-state.types";

interface InterceptStatsProps {
    isInsideModal?: boolean;
    subDimensionsData?: any[];
    id: string; //this prop allows ProgressScore component to scroll down to specific stat
}

const InterceptStats: React.FC<InterceptStatsProps> = ({
    isInsideModal,
    subDimensionsData,
    id,
}) => {
    const { statsSummaryData, isFetchingStatsSummary, isErrorStatsSummary } =
        useSessionDetailsContext();

    const areAllStatsEmpty = subDimensionsData?.every((statEntry: any) => {
        const datasets = Object.entries(statEntry?.datasets);

        return datasets?.length === 0;
    });

    const isEmptyState = () => {
        if (isInsideModal) {
            return !subDimensionsData || areAllStatsEmpty;
        } else if (
            !isErrorStatsSummary &&
            (!statsSummaryData ||
                statsSummaryData?.length === 0 ||
                statsSummaryData?.every((dataset: any) => {
                    return dataset.length === 0;
                }))
        ) {
            return true;
        }
    };

    if (isFetchingStatsSummary) {
        return <ContentLoader height="15rem" />;
    }

    if (isEmptyState()) {
        return (
            <ComponentWrapper>
                <EmptyState
                    title="session-details:intercept-stats:empty-state:title"
                    emptyStateType={EmptyStateType.Charts}
                    minHeight="15rem"
                />
            </ComponentWrapper>
        );
    }

    if (!subDimensionsData && isErrorStatsSummary && !isFetchingStatsSummary) {
        return (
            <ComponentWrapper>
                <EmptyState
                    title="error-state:title"
                    description="error-state:description"
                    emptyStateType={EmptyStateType.Error}
                    minHeight="15rem"
                />
            </ComponentWrapper>
        );
    }

    return (
        <InterceptStatsComponent
            data={isInsideModal ? subDimensionsData : statsSummaryData}
            id={id}
        />
    );
};

export default InterceptStats;
